import { Infra3DSDKError } from "./Infra3DSDKError";
export class ArgumentInfra3DSDKError extends Infra3DSDKError {
    constructor(message) {
        super(message != null ? message : "The argument is not valid.");
        Object.setPrototypeOf(this, ArgumentInfra3DSDKError.prototype);
        this.name = "ArgumentInfra3DSDKError";
    }
}
//# sourceMappingURL=ArgumentInfra3DSDKError.js.map